import { getLocationSettings } from "@glide/common-core/dist/js/location";
import { getAppFacilities } from "@glide/common-core/dist/js/support/app-renderer";
import { Agent } from "@glideapps/agent-lib";

export type RowsCallbackHandler = (rows: Record<string, unknown>[]) => void;
export type AgentCreator = ReturnType<typeof getAgentClientForAppID>;

export const getAgentClientForAppID =
    (appID: string, idToken: string | undefined, appUserID: string | undefined) =>
    (rowsCallbackHandler: RowsCallbackHandler) =>
        new Agent({
            endpoint: "/discovery-component",
            maxToolCalls: 10,
            getContext: async () => {
                return Promise.resolve({
                    app: {
                        appID,
                        name: "",
                        description: "",
                        tableNames: [],
                        screenNames: [],
                    },
                    mode: "Data",
                    user: {
                        appUserID,
                        displayName: "",
                        emails: [],
                    },
                    org: {
                        displayName: "",
                    },
                });
            },
            getUserIdToken: async () => {
                if (idToken !== undefined) {
                    return idToken;
                }
                try {
                    const userIdToken = await getAppFacilities().getIDToken();
                    return userIdToken;
                } catch (e: unknown) {
                    // eslint-disable-next-line no-console
                    console.error(
                        `Unable to get token in this environment!
                         Hint: if you can, mock the app facilities and implement a fake getIDToken().`
                    );
                    return "(no token)";
                }
            },

            getGatewayURL: () => {
                const locationSettings = getLocationSettings();
                if (locationSettings.isDevelopment) {
                    // TODO: not everyone is going to want this to do this locally
                    // We should probably return the staging URL instead... but we would have to solve for CORS anyway.
                    // return `https://staging.heyglide.com/${locationSettings.serviceGatewayLocation}agent-service`;
                    return `http://localhost:8081`;
                }
                // since these are now relative URls so they work in player,
                // we have to prepend the current hostname origin because the
                // agent is using URL constructor to make the URL there
                return `${window.location.origin}${locationSettings.serviceGatewayLocation}agent-service`;
            },
            callTool: async (_a, _b) => {
                return false;
            },
            toolCallFinish: toolCallEvent => {
                if (toolCallEvent.tool === "execute_sql") {
                    const tableArray = toolCallEvent.result?.richContent ?? [];
                    if (tableArray.length === 0) {
                        return;
                    }
                    if (tableArray[0].type !== "table") {
                        return;
                    }

                    const rowData = tableArray[0].rows;
                    rowsCallbackHandler(rowData);
                }
            },
        });
